// @ts-nocheck
import * as utils from '@wix/santa-editor-utils';

const { editorSessionId } = utils.editorModel;

export { editorSessionId };
